import React from "react";
import { useNavigate } from "react-router-dom";
import { useSetMenu } from "../../hooks/useSetMenu";
import { useStore } from '../../stores/store';
import { t } from "i18next";
function Home() {
  const navigate = useNavigate();
  const { mainStore, toolPassportStore } = useStore();
  useSetMenu(mainStore.HomeMenuType, mainStore.HomeMenuNo);

  const handleClick = (id) => {
    navigate("/Tools" + id);
    
  };

  return (
    <div className="container px-3 overflow-hidden">
      {/* Main Title */}
      <div className="row text-center">
        <h1>Welcome to Online-CADCOM</h1>
        <p>Online assisted Platform for Computer-aided design in communications</p>
      </div>
      {/* Panels - Side by Side on Desktop, Stacked on Mobile */}
      <div className="row gx-3">
        {/* Panel 1 (Left Side on Desktop) */}
        <div className="col-12 col-md-7 mb-2">
          <div className="myClass p-2">
            <div className="text-center mb-3">
              <p className="fw-bold">{t("panel")} 1</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/pnl_1.png`}
                alt="Panel 1"
                className="panelImage img-fluid"
              />
            </div>

            <div className="row">
              {/* Column 1 - Antenna, RF and microwave, Audio */}
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-2">
                <div className="box w-100" onClick={() => handleClick("/1/1")}>Antenna</div>
                <div className="box w-100" onClick={() => handleClick("/1/2")}>RF and microwave</div>
                <div className="box w-100" onClick={() => handleClick("/1/3")}>Audio</div>
              </div>
              {/* Column 2 - Analog, Interface ADC/DAC, Digital */}
              <div className="col-12 col-md-4 d-flex flex-column gap-2 mb-2">
                <div className="box w-100" onClick={() => handleClick("/1/4")}>Analog</div>
                <div className="box w-100" onClick={() => handleClick("/1/5")}>Interface ADC/DAC</div>
                <div className="box w-100" onClick={() => handleClick("/1/6")}>Digital</div>
              </div>
              <div className="col-12 col-md-4 d-flex">
                <div className="bigBox1 w-100" onClick={() => handleClick("/1/7")}>Power Supply</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-5 mb-2">
          <div className="myClass p-2">
            <div className="text-center mb-3">
              <p className="fw-bold">{t("panel")} 2</p>
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/pnl_2.png`}
                alt="Panel 2"
                className="panelImage img-fluid"
              />
            </div>
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div className="row g-2">
                  <div className="col-12">
                    <div className="box w-100" onClick={() => handleClick("/2/8")}>
                      PCB Design
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="box w-100" onClick={() => handleClick("/2/9")}>
                      Elements
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="box w-100" onClick={() => handleClick("/2/11")}>
                      Nano Technology
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex flex-column">
                <div
                  className="box mb-2 w-100"
                  onClick={() => handleClick("/2/10")}
                >
                  Electric Installation
                </div>

                <div className="flex-grow-1 d-flex">
                  <div
                    className="bigBox2 w-100" onClick={() => handleClick("/2/12")}
                  >
                    Outcome to Prototype:<br />
                    FPGA / CPLD / USRPs / Arduino
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
